import "./insWidget.scss";
import React from "react";
import { usePatchedWidgetComponentProps, useWidgetComponentProps } from "../hooks/use-current-widget";
import { InsWidgetFooter } from "./insWidgetFooter";
import { InsWidgetControls } from "./widget-controls";
import { preview } from "common/constants";
import { useIsEditMode } from "store/template/designer/selectors";
const renderHeader = (title, headerLeft, props) => React.createElement("div", { className: "insWidgetHeader" },
    React.createElement("div", { className: "widgetTextHeader left" },
        React.createElement("div", { className: "widgetTextHeaderBox" }, title ?? headerLeft)),
    React.createElement("div", { className: "right" },
        React.createElement(InsWidgetControls, { ...props })));
const renderSubHeaders = (title, headerLeft, headerRight) => {
    if ((title && headerLeft) || headerRight) {
        return (React.createElement("div", { className: "insWidgetHeader insWidgetSubheader" },
            React.createElement("div", { className: "left" }, title ? headerLeft : undefined),
            React.createElement("div", { className: "right" }, headerRight)));
    }
    return null;
};
const getFooterContent = (footer, sectionId, widgetId, errorMode, props) => {
    if (errorMode) {
        return React.createElement(React.Fragment, null);
    }
    if (footer) {
        return footer;
    }
    if (sectionId && widgetId) {
        return React.createElement(InsWidgetFooter, { ...props });
    }
    return null;
};
export const InsWidget = (props) => {
    const { errorMode, noMarginOnContent, sectionId, groupId, title, content, headerLeft, headerRight, footer, noCard, description } = props, compGroupProps = useWidgetComponentProps(sectionId, groupId), isPreviewMode = sectionId === preview.sectionId;
    const isEditMode = useIsEditMode() && !isPreviewMode;
    const { suppressExcelExport } = usePatchedWidgetComponentProps(sectionId, props.widgetId);
    const containerClass = [
        "insWidgetContainer",
        groupId && (compGroupProps?.widgets?.length > 1 || isEditMode) ? "insGroupedWidgetContainer" : "",
        noCard ? "insWidgetContainerNoCard" : "",
        props.fundWidget ? "insWidgetContainerFund" : "",
        props.reduceHeight ? "insWidgetContainerReduceHeight" : "",
        suppressExcelExport ? "hide-widget-on-pdf" : ""
    ].filter(Boolean).join(" ");
    return React.createElement("div", { className: containerClass },
        renderHeader(title, headerLeft, props),
        description && React.createElement("div", { className: "insWidgetDescription" }, description),
        React.createElement("div", { className: "insWidgetSubHeaders" }, renderSubHeaders(title, headerLeft, headerRight)),
        React.createElement("div", { className: `insWidgetContent ${noMarginOnContent ? "" : "insWidgetContentMargin"}` }, content),
        React.createElement("div", { className: "insWidgetFooter" }, getFooterContent(footer, sectionId, props.widgetId, errorMode, props)));
};
